/**
 * Popular location links use URL slugs like `quezon-city` while `address.city`
 * in the database uses human-readable names like `Quezon City`.
 */

export function normalizeLocationSlugForMatch(slug: string): string {
  return slug
    .trim()
    .replace(/%/g, '')
    .replace(/_/g, '')
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ')
    .toLowerCase();
}

/** Safe pattern for PostgREST `ilike` filters (wildcards stripped from user input). */
export function locationSlugToIlikePattern(slug: string): string | null {
  const n = normalizeLocationSlugForMatch(slug);
  if (!n) return null;
  return `%${n}%`;
}

export function propertyHaystackFromLocation(location: {
  city?: string;
  region?: string;
  address?: string;
}): string {
  return [location.city, location.region, location.address]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
    .replace(/-/g, ' ');
}

export function propertyMatchesLocationSlug(
  slug: string | null,
  location: { city?: string; region?: string; address?: string }
): boolean {
  if (!slug?.trim()) return true;
  const needle = normalizeLocationSlugForMatch(slug);
  if (!needle) return true;
  const hay = propertyHaystackFromLocation(location);
  return hay.includes(needle);
}
